import store from '../store/singleton'

class FcmStore {
  static install(Vue, options) {
    Vue.prototype.$singletonStore = store
  }
}

export default FcmStore
